export default "/images/d7a068e9cda371da961141a3fb6b5ac8.avif";